import Vue from 'vue'
import $ from 'jquery'
import axios from 'axios'
import moment from "moment";
const BaseApi = {
  reqGetHitlist: { state: null },
  currentModuleId: 'unknown',
  lastDebugTm: new Date().getTime(),
  lastModuleConfig: null,
  idleCnt: 0,
  splitChar: '$',
  paramData: {
    clientNr: null,
    clientDatabase: null,
    clientDatabaseNr: null,
    publicDatabase: null,
    publicDatabaseNr: null
  },
  showIdle: function (message) {
    this.idleCnt = this.idleCnt + 1
    if (message) {
      Vue.prototype.$eventHub.$emit('OnShowIdle', {
        show: true,
        message: message
      })
    } else {
      Vue.prototype.$eventHub.$emit('OnShowIdle', true)
    }
  },
  hideIdle: function () {
    this.idleCnt = this.idleCnt - 1
    // console.log('hideIdle', this.idleCnt, this.getStackTrace())
    if (this.idleCnt <= 0) {
      this.idleCnt = 0
      Vue.prototype.$eventHub.$emit('OnShowIdle', false)
    }
  },
  getViewport() {
    var e = window
    var a = 'inner'
    if (!('innerWidth' in window)) {
      a = 'client'
      e = document.documentElement || document.body
    }
    return {width: e[a + 'Width'], height: e[a + 'Height']}
  },
  /**
   * Vue.prototype.$api.debug()
   * @param msg
   * @param objects
   * @param objects1
   * @param objects2
   * @param objects3
   */
  debug(msg, objects, objects1, objects2, objects3) {

    if (Vue.prototype.$config && Vue.prototype.$config.IS_DEBUG) {
      var log = []
      if (objects) log.push(objects)
      if (objects1) log.push(objects1)
      if (objects2) log.push(objects2)
      if (objects3) log.push(objects3)
      var diff = new Date().getTime() - this.lastDebugTm
      msg = '' + diff + ':' + msg
      console.log(msg, log)
      this.lastDebugTm = new Date().getTime()
      // Vue.prototype.$api.getStackTrace()

    }
  },
  setModuleId(moduleId) {
    // console.log('setModuleId', this.currentModuleId, moduleId, this.getStackTrace())
    this.currentModuleId = moduleId
  },
  isSuperAdmin() {
    if (this.getCredentials()) {
      if (this.getCredentials().data.user.isAdmin) {
        return true
      }
    }
    return false
  },
  isAdmin() {
    if (this.getCredentials()) {
      if (this.getCredentials().data.user.isAdmin) {
        return true
      }
    }
    return false
  },
  getModuleId() {
    return this.currentModuleId
  },
  fillRowItem(cmp, rowItem) {
    var cmp = this
    try {
      if (rowItem.field === 'aa') {
        rowItem.type = 'dropdownms'
        rowItem.itemList = Vue.prototype.storage.getAbschlussartList()
      } else if (rowItem.field === 'source') {
        rowItem.type = 'dropdown'
        rowItem.itemList = Vue.prototype.storage.getSourcesListFiltered()
      } else if (rowItem.field === 'region') {
        rowItem.type = 'dropdownms'
        rowItem.itemList = Vue.prototype.storage.getRegionList()
      } else if (rowItem.field === 'rk') {
        rowItem.type = 'dropdownms'
        rowItem.itemList = Vue.prototype.storage.getRechtskreise()
      } else if (rowItem.field === 'waehrung') {
        rowItem.type = 'dropdown'
        rowItem.itemList = Vue.prototype.storage.getCurrencyList()
      } else if (rowItem.field === 'branchCategory') {
        rowItem.type = 'dropdownms'
        rowItem.itemList = Vue.prototype.storage.getBranchList()
      } else if (rowItem.field === 'category') {
        rowItem.type = 'dropdownms'
        rowItem.itemList = Vue.prototype.storage.getBranchList()
      } else if (rowItem.field === 'country') {
        rowItem.type = 'dropdownms'
        rowItem.itemList = Vue.prototype.storage.getCountryList()
      } else if (rowItem.field === 'rating') {
        rowItem.type = 'fromtodropdown'
        rowItem.itemList = Vue.prototype.storage.getRating()
      } else if (rowItem.field === 'bankscore') {
        rowItem.type = 'fromto'
        rowItem.itemList = Vue.prototype.storage.getRating()
      } else if (rowItem.field === 'ratingKunde') {
        rowItem.type = 'fromtodropdown'
        rowItem.itemList = Vue.prototype.storage.getRatingKunde()
      } else if (rowItem.field === 'przFromAnkerbank') {
        rowItem.type = 'dropdownms'
        rowItem.itemList = cmp.przList
      } else if (rowItem.field === 'ultimutt') {
        rowItem.type = 'checkbox'
      } else if (rowItem.dbType === 'STATE') {
        rowItem.type = 'checkbox'
      }
    } catch (exception) {
      console.error(exception, exception)
    }

  },
  /**
   * ($HTTP_DIR/order/alertForPeergroup.php?crefoNr=$crefoNr, wobei $CrefoNr=CrefoNr aus JahresabschlussPeergroup).
   * Die Information, ob die Alert-Funktion aktiviert bzw.
   * deaktiviert ist wird in einer Tabelle $SESSION['userDatabase'].userAlert gespeichert.
   * @param cmp
   * @param orderNr
   * @param isActive
   */
  setAlertFunction(cmp, crefoNr, isActive, onSuccess, onFailure) {
    // Vue.prototype.$api.debug('setAlertFunction', crefoNr, isActive)
    var isActiveStr = 'off'
    if (isActive) {
      isActiveStr = 'on'
    }
    /*
    var url = window.HTTP_DIR + '/order/alertForPeergroup.php'
    var params = {
      crefoNr: crefoNr,
      isActive: isActiveStr
    }
    $.get(url, params, function (data) {
      callback(data)
    }, 'json').fail(onFailed)
    */

    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'set',
      active: isActiveStr,
      CrefoNr: crefoNr,
      userID: Vue.prototype.storage.getUserId()
    }

    params = this.injectRequestData(params)

    axios({
      method: 'post',
      data: JSON.stringify(params),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (onSuccess) {
          onSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (onFailure) {
          onFailure(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  getBankDataByTriple(data, onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'bankData',
      userID: Vue.prototype.storage.getUserId(),
      data: data
    }
    data.userID = Vue.prototype.storage.getUserId()
    data.language = this.getLanguage()
    $.post(url, JSON.stringify(params), function (data) {
      if (data.isException) {
        Vue.prototype.$api.onException(data)
      }
      onSuccess(data)
    }, 'json')
  },
  isFavouriteActive: function (crefoNr, onSuccess, onFailure) {
    Vue.prototype.$api.debug('isFavouriteActive')
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'isFavouriteActive',
      crefoNr: crefoNr,
      userID: Vue.prototype.storage.getUserId()
    }
    params = this.injectRequestData(params)
    axios({
      method: 'post',
      data: JSON.stringify(params),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (onSuccess) {
          onSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (onFailure) {
          onFailure(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  setCredentials: function (credentials) {
    this.credentials = credentials
    if (window.localStorage) {
      window.localStorage.credentials = JSON.stringify(credentials)
    }
  },
  getCredentials: function () {
    var result = this.credentials
    if (!result) {
      if (window.localStorage) {
        result = JSON.parse(window.localStorage.credentials)
      }
    }
    return result
  },
  // TODO maybe obsolete
  getColumnsString(headerFields) {
    var filterString = ''
    for (var rowIndex in headerFields) {
      var hf = headerFields[rowIndex]
      if (filterString.length > 0) {
        filterString = filterString + ','
      }
      filterString = filterString + hf.type + ':' + hf.id + ':0'
    }
    return filterString
  },
  createStructureData(reqData, fnSuccess, fnError) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-STRUCT'
    reqData = this.injectRequestData(reqData)
    reqData = this.fillCompanyAndBalance(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  balanceToString(balance) {
    if (!balance) return '-1:-1:-1:-1:-1'
    return balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
  },
  stringToBalance(balance) {
    var arr = balance.split(':')
    var res = {
      crefoNr: arr[0],
      year: arr[1],
      aaNr: arr[2],
      rkNr: arr[3],
      source: arr[4]
    }
    // return balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    return res
  },
  createStructureDataWithBalance(balance, configName, fnSuccess, fnError) {
    console.log(['createStructureDataWithBalance', balance])
    var reqData = {
      company: this.balanceToString(balance),
      configName: configName,
      createPosition: 1
    }
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-STRUCT'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    reqData = this.fillCompanyAndBalance(reqData)
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  /**
   * WZBereich: this.wzcodeselect.WZBereich, WZCodeArtNr
   * @param reqData
   * @param fnSuccess
   * @param fnError
   */
  getWZCodeData(reqData, fnSuccess, fnError) {
    var reqData = {
      WZBereich: reqData.WZBereich,
      WZCodeArtNr: reqData.WZCodeArtNr,
      wcode: '*'
    }
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-WZCODE'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  getWZCodeGroups(fnSuccess, fnError) {
    var reqData = {
      wcode: '*'
    }
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-WZCODE-GROUPS'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  deletePeergroupList(id, callback) {
    var url = Vue.prototype.storage.host() + '/ajaxPeergroup.php'
    var data = {
      action: 'delete',
      language: this.getLanguage(),
      id: id
    }
    data = this.injectRequestData(data)
    $.post(url, JSON.stringify(data), function (data) {
      callback(data)
    }, 'json')
  },
  /* Vue.prototype.$api.renamePeergroupList(id, name)*/
  renamePeergroupList(id, newName, callback) {
    var url = Vue.prototype.storage.host() + '/ajaxPeergroup.php'
    var data = {
      action: 'rename',
      language: this.getLanguage(),
      id: id,
      bezeichnung: newName
    }
    data = this.injectRequestData(data)
    $.post(url, JSON.stringify(data), function (data) {
      callback(data)
    }, 'json')
  },
  /* Vue.prototype.$api.getPeergroupList(this.onGetPeergroupList)*/
  getPeergroupList(callback) {
    var url = Vue.prototype.storage.host() + '/ajaxPeergroup.php'
    var data = {
      action: 'get',
      language: this.getLanguage()
    }
    data = this.injectRequestData(data)
    $.post(url, JSON.stringify(data), function (data) {
      callback(data)
    }, 'json')
  },
  savePeergroup(reqData, onSuccess, onFailure) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxPeergroup.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.action = 'put'
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      if (onSuccess) {
        onSuccess(data)
      }
    }, 'json')
  },
  loadPeergroupListById(pgListId, onSuccess, onFailure) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxPeergroup.php'
    Vue.prototype.$api.resetAll()
    var reqData = {}
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.peergroupId = pgListId
    reqData.action = 'load'
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      if (onSuccess) {
        onSuccess(data)
      }
    }, 'json')
  },
  createStructureDataWithBalanceArray(arr, configName, onSuccess, onFailure) {
    var reqData = {
      peergroup: '',
      company: '',
      configName: configName,
      createPosition: 1
    }
    var dismissBalance = null
    if (Vue.prototype.storage.hasAnkerBank) {
      dismissBalance = Vue.prototype.$api.balanceToString(Vue.prototype.storage.ankerBankBalance)
    }
    for (var index in arr) {
      var balance = arr[index]
      var bToAdd = Vue.prototype.$api.balanceToString(balance)
      if (dismissBalance && (bToAdd === dismissBalance)) continue
      reqData.peergroup += bToAdd + ','
    }
    if (reqData.peergroup.length > 0) reqData.peergroup = reqData.peergroup.substr(0, reqData.peergroup.length - 1)
    if (Vue.prototype.storage.hasAnkerBank) {
      Vue.prototype.$api.debug('add', Vue.prototype.storage.ankerBankBalance)
      Vue.prototype.$api.debug('add', Vue.prototype.storage.ankerBank)
      reqData.company = Vue.prototype.$api.balanceToString(Vue.prototype.storage.ankerBankBalance)
    }
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-STRUCT'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    reqData = this.fillCompanyAndBalance(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },
  createOrderNumbersWithBalanceArray(arr, onSuccess, onFailure) {
    var reqData = {
      peergroup: '',
      company: ''
    }
    reqData = this.fillCompanyAndBalance(reqData)
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-ORDERNUMBERS'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },
  getExportFormats(balance, fnSuccess, fnError) {
    let url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    let params = {
      time: new Date().getTime()
    }
    var reqData = {
      peergroup: '',
      company: ''
    }
    reqData = this.fillCompanyAndBalance(reqData)
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-GET-EXPORTFORMATS'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      params: params,
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createOrderNumbersWithBalance(balance, onSuccess, onFailure) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source,
      crefoNr: balance.crefoNr
    }

    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-ORDERNUMBERS'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },
  /**
   * Returns the change log data
   * @param onSuccess
   * @param onFailure
   * Vue.prototype.$api.getChangeLogData(this.onGetChangeLogData)
   */
  getChangeLogData(onSuccess, onFailure) {
    var reqData = {}
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-CHANGELOG'
    if (Vue.prototype.$api.getCredentials() && Vue.prototype.$api.getCredentials().data.user) {
      reqData.clientNr = Vue.prototype.$api.getCredentials().data.user.userClientNr
    }
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },
  getStammDataWithBalance(balance, logging, onSuccess, onFailure) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source,
      crefoNr: balance.crefoNr
    }
    reqData = this.fillCompanyAndBalance(reqData)


    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-STAMMDATA'
    reqData.logging = logging
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },
  getTabInformations(isPeergroup, arr, balance, fnSuccess, fnError) {
    var reqData = Vue.prototype.$api.getProducts()
    reqData.peergroup = ''
    if (!isPeergroup) {
      reqData.company = balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source,
      reqData.crefoNr = balance.crefoNr
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-STRUCT-INFO'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    reqData.bilko = false
    if (Vue.prototype.$api.getModuleId() === 'banks' && Vue.prototype.$api.hasProduct('bilkoBank')) {
      reqData.bilko = true
    } if (Vue.prototype.$api.getModuleId() === 'companies' && Vue.prototype.$api.hasProduct('bilko')) {
      reqData.bilko = true
    }
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  getStammDataWithBalanceArray(arr, logging, onSuccess, onFailure) {
    var reqData = {
      // company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source,
      // crefoNr: balance.crefoNr
      peergroup: ''
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-STAMMDATA'
    reqData.logging = logging
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },
  getStammDataWithBalanceArrayLimit1(arr,logging, onSuccess, onFailure) {
    var reqData = {
      // company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source,
      // crefoNr: balance.crefoNr
      peergroup: ''
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-STAMMDATA'
    reqData.logging = logging
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    reqData.peerDataLimit = 1
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },
  getRohbilanzDataWithBalance(balance, onSuccess, onFailure) {
    if (!balance) return
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-ROHBILANZ'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },

  getKDFDataWithBalance(balance, onSuccess, onFailure) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-KDF'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },
  downloadPDF(excelConfig, orderId, type) {
    var cmp = this
    var config = excelConfig
    var url = Vue.prototype.storage.host() + '/ajaxGetBankOrderAsPDF.php?type=' + type + '&orderId=' + orderId
    url = url + '&userdb=' + Vue.prototype.$api.userdb + '&language=' + this.getLanguage()
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'blob';
    let formData = new FormData();
    formData.set('type', excelConfig.type);
    formData.set('userID', Vue.prototype.storage.getUserId());
    formData.set('configName', excelConfig.configName);
    formData.set('language', this.getLanguage());
    formData.set('currency', Vue.prototype.storage.getCurrency());
    formData.set('currencyDimension', Vue.prototype.storage.getCurrencyDimension());
    formData.set('bank', Vue.prototype.$api.balanceToString(excelConfig.balance));

    this.injectPostData(formData);

    xhr.send(formData);


    xhr.onload = function (e) {
      // onSuccess(e)
      if (this.status == 200) {
        // Create a new Blob object using the response data of the onload object
        var blob = new Blob([this.response], {type: 'image/pdf'});
        //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
        let a = document.createElement("a");
        a.style = "display: none";
        document.body.appendChild(a);
        //Create a DOMString representing the blob and point the link element towards it
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = config.fileName + '.pdf';
        //programatically click the link to trigger the download
        a.click();
        //release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
      } else {
        onFailure(e)
      }
      Vue.prototype.$api.hideIdle()
    };
  },
  getDocuments(balance, orderArray, onSuccess, onFailure) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }
    reqData = this.fillCompanyAndBalance(reqData)
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-DOCUMENTS'
    reqData.orderList = orderArray.join()
    reqData = this.injectRequestData(reqData)
    $.post(url, JSON.stringify(reqData), function (data) {
      onSuccess(data)
    }, 'json')
  },

  getBlianzRatingGraphWithBalance(balance, fnSuccess, fnError) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-BILANZRATING-GRAPH'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()

    reqData = this.injectRequestData(reqData)
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'blob'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  getBlianzRatingDataWithBalance(balance, fnSuccess, fnError) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-BILANZRATING'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()

    reqData = this.injectRequestData(reqData)
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createKennzahlenDataWithBalance(balance, configName, fnSuccess, fnError) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source,
      configName: configName
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-KENNZAHLEN'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },

  fillCompanyAndBalance(reqData) {
    reqData.peergroup = ''
    if (Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())) {
      reqData.company = Vue.prototype.$api.balanceToString(Vue.prototype.storage.getAnkerbank(Vue.prototype.$api.getModuleId()))
      // console.log('is ankerbank', reqData.company)
    } else {
      // console.log('missing ankerbank', reqData.company)
    }

    var arr = Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId())
    if (arr) {
      for (var index in arr) {
        var balance = arr[index]
        if (balance.isAnkerBank) continue
        var balanceStr = balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source + ','
        // if (balanceStr.indexOf(reqData.company) > -1) continue
        reqData.peergroup += balanceStr
      }
      reqData.peergroup = reqData.peergroup.substr(0, reqData.peergroup.length - 1)
    }
    var credits = this.getCredentials()
    var arr = {}
    for (var index in credits.productList) {
      var product = credits.productList[index]
      reqData[product.id] = true
    }
    return reqData
  },
  createKennzahlenDataWithBalanceArray(arr, configName, fnSuccess, fnError) {
    var reqData = {
      // peergroup: '',
      configName: configName
      // company: ''
    }
    reqData = this.fillCompanyAndBalance(reqData)
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-KENNZAHLEN'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  getAXSemantics(balance, reCreate, fnSuccess, fnError) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-AX-TEXT'
    reqData.createNew = '0'
    if (reCreate) {
      reqData.createNew = '1'
    }
    reqData.databaseNr = '-1'
    if ((balance.source + '') === '1') { // public
      reqData.databaseNr = this.getParamData().publicDatabaseNr
    } else {
      reqData.databaseNr = this.getParamData().clientDatabaseNr
    }
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  checkBalanceExists(balance, fnSuccess, fnError) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.type = 'BALANCE_EXISTS'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createBankenscoreDataWithBalance(balance, fnSuccess, fnError) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-BANKSCORE'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createBankenscoreDataWithBalanceArray(arr, fnSuccess, fnError) {
    var reqData = {
      peergroup: '',
      company: ''
    }
    reqData = this.fillCompanyAndBalance(reqData)


    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-BANKSCORE'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createVerflechtungHierachyDataWithBalance(balance, levelLimit, fnSuccess, fnError) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-KONZERNVERBUND-HIERARCHISCH'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData.levelLimit = levelLimit
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createVerflechtungDataWithBalance(balance, fnSuccess, fnError) {
    var reqData = {
      company: balance.crefoNr + ':' + balance.year + ':' + balance.aaNr + ':' + balance.rkNr + ':' + balance.source
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-KONZERNVERBUND-BANKEN-INFO'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  createVerflechtungDataWithBalanceArray(arr, fnSuccess, fnError) {
    var reqData = {
      peergroup: '',
      company: ''
    }
    reqData = this.fillCompanyAndBalance(reqData)

    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    reqData.userID = Vue.prototype.storage.getUserId()
    reqData.type = 'JSON-KONZERNVERBUND-BANKEN-INFO'
    reqData.currency = Vue.prototype.storage.getCurrency()
    reqData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()
    reqData = this.injectRequestData(reqData)

    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  getStructureUrlOfArray(idModule, balanceArray) {
    var aaNr = ''
    var crefoNr = ''
    var rkNr = ''
    var source = ''
    var year = ''
    for (var i in balanceArray) {
      var item = balanceArray[i]
      if (aaNr.length > 0) aaNr += ','
      aaNr = aaNr + item.aaNr

      if (crefoNr.length > 0) crefoNr += ','
      crefoNr = crefoNr + item.crefoNr

      if (rkNr.length > 0) rkNr += ','
      rkNr = rkNr + item.rkNr

      if (source.length > 0) source += ','
      source = source + item.source

      if (year.length > 0) year += ','
      year = year + item.year
    }

    var url = '/di/StructureDataDetailed/' + idModule + '/' + aaNr + '/' + crefoNr + '/' + rkNr + '/' + source + '/' + year
    return url
  },
  convertToWaimeaDecimal(format, value) {
    // value = ('' + value).replace(/\./g, '')
    // value = ('' + value).replace(/,/g, '.')
    var maximumFractionDigits = 0
    var minimumFractionDigits = 0

    if (format.toLowerCase() === 'f2t') {
      maximumFractionDigits = 2
      minimumFractionDigits = 2
    }
    if (format.toLowerCase() === 'f0t') {
      maximumFractionDigits = 0
      minimumFractionDigits = 0
    }
    if (format.toLowerCase() === 'f1t') {
      maximumFractionDigits = 1
      minimumFractionDigits = 1
    }
    var vvv = (1 * value).toLocaleString('de-DE', {
      style: 'decimal',
      useGrouping: true,
      maximumFractionDigits: maximumFractionDigits,
      minimumFractionDigits: minimumFractionDigits
    })
    return vvv
  },
  getStructureUrl(idModule, balance) {
    balance.crefoNr = balance.crefoNr.replace('#', '_')

    var url = '/di/StructureDataDetailed/' + idModule + '/' + balance.aaNr + '/' + balance.crefoNr + '/' + balance.rkNr + '/' + balance.source + '/' + balance.year
    return url
  },
  getStructureAnchorUrl(idModule, balance) {
    balance.crefoNr = balance.crefoNr.replace('#', '_')

    var url = '/di/StructureDataAnchor/' + idModule + '/' + balance.aaNr + '/' + balance.crefoNr + '/' + balance.rkNr + '/' + balance.source + '/' + balance.year
    return url
  },

  clearGroupData(ankerBank, ankerBankData) {
    Vue.prototype.storage.groupData = []
    Vue.prototype.storage.ankerBankBalance = null
    Vue.prototype.storage.hasAnkerBank = false
    Vue.prototype.storage.setAnkerbankData(Vue.prototype.$api.getModuleId(), ankerBankData)
    Vue.prototype.storage.clearState('pgLastHitList')
    if (ankerBank) {
      Vue.prototype.storage.hasAnkerBank = true
      Vue.prototype.storage.groupData.push(ankerBank)
      Vue.prototype.storage.ankerBankBalance = ankerBank
    }
  },
  checkBalanceExistsInGroup(balanceToCheck) {
    var b1s = this.balanceToString(balanceToCheck)
    for (var index in Vue.prototype.storage.groupData) {
      var balanceInGroup = Vue.prototype.storage.groupData[index]
      var b2s = this.balanceToString(balanceInGroup)
      if (b1s === b2s) {
        return true
      }
    }
    return false
  },
  compareBalance(b1, b2) {
    var b1s = this.balanceToString(b1)
    var b2s = this.balanceToString(b2)
    return b1s === b2s
  },
  compareBalanceWithoutYear(b1, b2) {
    var result = false
    b1 = JSON.parse(JSON.stringify(b1))
    b2 = JSON.parse(JSON.stringify(b2))
    b1.year = b2.year
    var b1s = this.balanceToString(b1)
    var b2s = this.balanceToString(b2)
    return b1s === b2s
  },
  compareBalanceWithoutYearAndRK(b1, b2) {
    b1 = JSON.parse(JSON.stringify(b1))
    b2 = JSON.parse(JSON.stringify(b2))
    b1.year = b2.year
    b1.rkNr = b2.rkNr
    var b1s = this.balanceToString(b1)
    var b2s = this.balanceToString(b2)
    return b1s === b2s
  },
  getPeegroupSearchUrl(idModule, balance) {
    balance.crefoNr = balance.crefoNr.replace('#', '_')
    var url = '/di/peergroup/' + idModule + '/' + balance.aaNr + '/' + balance.crefoNr + '/' + balance.rkNr + '/' + balance.source + '/' + balance.year
    return url
  },
  checkReportExists(excelConfig, onSuccess, onFailure) {
    Vue.prototype.$api.debug('downloadPDFReport', excelConfig)
    var cmp = this
    var config = excelConfig
    var url = Vue.prototype.storage.host() + '/ajaxGetReport.php'
    // reqData.type = type
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'blob';
    let formData = new FormData();
    formData.set('type', excelConfig.type);
    formData.set('userID', Vue.prototype.storage.getUserId());
    formData.set('configName', excelConfig.configName);
    formData.set('language', this.getLanguage());
    formData.set('returnFile', 0);
    formData.set('currency', Vue.prototype.storage.getCurrency());
    formData.set('currencyDimension', Vue.prototype.storage.getCurrencyDimension());
    formData.set('bank', Vue.prototype.$api.balanceToString(excelConfig.balance));

    this.injectPostData(formData);

    xhr.send(formData);

    xhr.onload = function (e) {

      if (this.status == 200) {
        var blob = new Blob([this.response], {type: 'application/json'});
        var fr = new FileReader();

        fr.onload = function () {
          if (onSuccess) onSuccess(JSON.parse(this.result))
        };

        fr.readAsText(blob);

      } else {
        onFailure(e)
      }
    };
  },
  downloadPDFReport(excelConfig, onSuccess, onFailure) {
    Vue.prototype.$api.debug('downloadPDFReport', excelConfig)
    var cmp = this
    var config = excelConfig
    var url = Vue.prototype.storage.host() + '/ajaxGetReport.php'
    // reqData.type = type
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'blob';
    let formData = new FormData();
    formData.set('type', excelConfig.type);
    formData.set('userID', Vue.prototype.storage.getUserId());
    formData.set('configName', excelConfig.configName);
    formData.set('language', this.getLanguage());
    formData.set('returnFile', 1);
    formData.set('currency', Vue.prototype.storage.getCurrency());
    formData.set('currencyDimension', Vue.prototype.storage.getCurrencyDimension());
    formData.set('bank', Vue.prototype.$api.balanceToString(excelConfig.balance));

    this.injectPostData(formData);

    xhr.send(formData);

    xhr.onload = function (e) {
      if (onSuccess) onSuccess(e)
      if (this.status == 200) {
        // Create a new Blob object using the response data of the onload object
        var blob = new Blob([this.response], {type: 'image/pdf'});
        //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
        let a = document.createElement("a");
        // dow not work in IE a.style = "display: none";
        document.body.appendChild(a);
        //Create a DOMString representing the blob and point the link element towards it
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = config.fileName + '.pdf';
        //programatically click the link to trigger the download
        a.click();
        //release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
      } else {
        onFailure(e)
      }
      Vue.prototype.$api.hideIdle()
    };
  },
  downloadBilanzFile(excelConfig, onSuccess, onFailure) {
    Vue.prototype.$api.debug('downloadBilanzFile', excelConfig)
    var cmp = this
    var config = excelConfig
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    // reqData.type = type
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'blob';
    let formData = new FormData();
    formData.set('type', excelConfig.type);
    formData.set('userID', Vue.prototype.storage.getUserId());
    formData.set('configName', excelConfig.configName);
    formData.set('language', this.getLanguage());
    formData.set('returnFile', 1);
    formData.set('bilanztypNr', excelConfig.bilanztypNr);
    formData.set('currency', Vue.prototype.storage.getCurrency());
    formData.set('currencyDimension', Vue.prototype.storage.getCurrencyDimension());
    formData.set('company', Vue.prototype.$api.balanceToString(excelConfig.balance));

    this.injectPostData(formData);
    if ((excelConfig.balance.source + '') === '1') { // public
      excelConfig.databaseNr = this.getParamData().publicDatabaseNr
    } else {
      excelConfig.databaseNr = this.getParamData().clientDatabaseNr
    }
    formData.set('databaseNr', excelConfig.databaseNr);

    xhr.send(formData);

    xhr.onload = function (e) {
      if (onSuccess) onSuccess(e)
      if (this.status == 200) {
        // Create a new Blob object using the response data of the onload object
        var blob = new Blob([this.response], {type: 'image/pdf'});
        //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
        let a = document.createElement("a");
        // dow not work in IE a.style = "display: none";
        document.body.appendChild(a);
        //Create a DOMString representing the blob and point the link element towards it
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = config.fileName + '.' + config.extension;
        //programatically click the link to trigger the download
        a.click();
        //release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
      } else {
        onFailure(e)
      }
      Vue.prototype.$api.hideIdle()
    };
  },
  injectPostData(reqData) {
    reqData.set('language', this.getLanguage());
    reqData.set('module', this.getModuleId());
    if (this.paramData) {
      if (this.paramData.clientNr) reqData.set('clientNr', this.paramData.clientNr);
      if (this.paramData.clientDatabase) reqData.set('clientDatabase', this.paramData.clientDatabase);
      if (this.paramData.clientDatabaseNr) reqData.set('clientDatabaseNr', this.paramData.clientDatabaseNr);
      if (this.paramData.publicDatabase) reqData.set('publicDatabase', this.paramData.publicDatabase);
      if (this.paramData.publicDatabaseNr) reqData.set('publicDatabaseNr', this.paramData.publicDatabaseNr);
      reqData.set('peerDataLimit', 100);
    }
    Vue.prototype.$api.debug('injectPostData', reqData)
    return reqData
  },
  exportFileToExcel(excelConfig, onSuccess, onFailure) {
    Vue.prototype.$api.debug('exportFileToExcel', excelConfig)
    var cmp = this
    var config = excelConfig
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    // reqData.type = type
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'blob';
    let formData = new FormData();
    formData.set('type', excelConfig.type);
    formData.set('userID', Vue.prototype.storage.getUserId());
    formData.set('configName', Vue.prototype.storage.getConfigName());
    formData.set('language', this.getLanguage());
    formData.set('currency', Vue.prototype.storage.getCurrency());
    formData.set('currencyDimension', Vue.prototype.storage.getCurrencyDimension());
    formData.set('excelHideColumns', excelConfig.excelHideColumns)
    formData.set('createPosition', 1);
    formData.set('sort', excelConfig.sort)
    formData.set('mode', 'excel');
    if (this.isAdmin()) {
      formData.set('excelSheetDebugInfo',1);
    }  else {
      formData.set('excelSheetDebugInfo',0);
    }


    this.injectPostData(formData);
    var bData = {}
    if (excelConfig.SAcompany && excelConfig.SAcompany) {
      bData.company = excelConfig.SAcompany
    }

    bData = this.fillCompanyAndBalance(bData)

    if (!excelConfig.excelSheetStammdaten) excelConfig.excelSheetStammdaten = 0
    if (!excelConfig.excelSheetStrukturbilanz) excelConfig.excelSheetStrukturbilanz = 0
    if (!excelConfig.excelSheetRohbilanz) excelConfig.excelSheetRohbilanz = 0
    if (!excelConfig.excelSheetKennzahlen) excelConfig.excelSheetKennzahlen = 0
    if (!excelConfig.excelSheetBilanzrating) excelConfig.excelSheetBilanzrating = 0
    if (!excelConfig.excelSheetBankscore) excelConfig.excelSheetBankscore = 0
    if (!excelConfig.excelSheetVerflechtung) excelConfig.excelSheetVerflechtung = 0
    if (!excelConfig.excelSheetVerflechtungHierarchisch) excelConfig.excelSheetVerflechtungHierarchisch = 0
    if (!excelConfig.excelSheetPG2BILANZ) excelConfig.excelSheetPG2BILANZ = 0

    formData.set('excelSheetBankscore', excelConfig.excelSheetBankscore)
    formData.set('excelSheetVerflechtung', excelConfig.excelSheetVerflechtung)
    formData.set('excelSheetVerflechtungHierarchisch', excelConfig.excelSheetVerflechtungHierarchisch)
    formData.set('excelSheetStammdaten', excelConfig.excelSheetStammdaten)
    formData.set('excelSheetStrukturbilanz', excelConfig.excelSheetStrukturbilanz)
    formData.set('excelSheetRohbilanz', excelConfig.excelSheetRohbilanz)
    formData.set('excelSheetKennzahlen', excelConfig.excelSheetKennzahlen)
    formData.set('excelSheetBilanzrating', excelConfig.excelSheetBilanzrating)
    formData.set('excelSheetPG2Bilanz', excelConfig.excelSheetPG2BILANZ)
    formData.set('excelSheetKDF', excelConfig.excelSheetKDF)
    if (bData && bData.company) {
      formData.set('company', bData.company)
    }
    if (bData && bData.peergroup) {
      formData.set('peergroup', bData.peergroup)
    }
    /*
    if (excelConfig.SAcompany && excelConfig.SAcompany) {
      formData.set('company', excelConfig.SAcompany)
    }
    if (excelConfig.SApeergroup) {
      formData.set('peergroup', excelConfig.SApeergroup)
    }

     */
    formData = this.fillCompanyAndBalance(formData)

    xhr.send(formData);

    xhr.onload = function (e) {
      if (onSuccess) onSuccess(e)
      if (this.status == 200) {
        // Create a new Blob object using the response data of the onload object
        var blob = new Blob([this.response], {type: 'image/pdf'});
        //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
        let a = document.createElement("a");
        // does not work in IE a.style = "display: none";
        document.body.appendChild(a);
        //Create a DOMString representing the blob and point the link element towards it
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = config.fileName + '.xlsx';
        a.target = '_new';
        //programatically click the link to trigger the download
        a.click();
        //release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
      } else {
        onFailure(e)
      }
    };
  },
  exportAXToDoc(excelConfig, onSuccess, onFailure) {
    Vue.prototype.$api.debug('exportAXToDoc', excelConfig)
    var config = excelConfig
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.responseType = 'blob';
    let formData = new FormData();
    formData.set('type', "JSON-AX-TEXT-DOC");
    formData.set('userID', Vue.prototype.storage.getUserId());
    formData.set('configName', Vue.prototype.storage.getConfigName());
    formData.set('language', this.getLanguage());
    formData.set('currency', Vue.prototype.storage.getCurrency());
    formData.set('currencyDimension', Vue.prototype.storage.getCurrencyDimension());
    formData.set('mode', 'doc');

    this.injectPostData(formData);
    var bData = {}
    if (excelConfig.balance) {
      if ((excelConfig.balance.source + '') === '1') { // public
        formData.set('databaseNr', this.getParamData().publicDatabaseNr)
      } else {
        formData.set('databaseNr', this.getParamData().clientDatabase)
      }
      bData.company = this.balanceToString(excelConfig.balance)
    }

    // bData = this.fillCompanyAndBalance(bData)

    if (bData && bData.company) {
      formData.set('company', bData.company)
    }
    if (bData && bData.peergroup) {
      formData.set('peergroup', bData.peergroup)
    }
    formData = this.fillCompanyAndBalance(formData)

    xhr.send(formData);

    xhr.onload = function (e) {
      if (onSuccess) onSuccess(e)
      if (this.status == 200) {
        // Create a new Blob object using the response data of the onload object
        var blob = new Blob([this.response], {type: 'image/pdf'});
        //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
        let a = document.createElement("a");
        // does not work in IE a.style = "display: none";
        document.body.appendChild(a);
        //Create a DOMString representing the blob and point the link element towards it
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = config.fileName + '.docx';
        a.target = '_new';
        //programatically click the link to trigger the download
        a.click();
        //release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
      } else {
        onFailure(e)
      }
    };
  },
  getI18NCurrency: function (nr) {
    if (!this.i18nCurrency) return ''
    return this.i18nCurrency['' + nr]
  },
  getI18NCurrencyDimension: function (nr) {
    var key = nr + '_' + this.lanId
    // console.log('i18nCurrencyDimension', this.i18nCurrencyDimension, nr, key)
    if (!this.i18nCurrencyDimension) return {'name': ''}
    var res = this.i18nCurrencyDimension[key]
    if (!res) {
      res = {'name': ''}
    }
    return res
  },
  getI18NRechtsKreis: function (nr) {
    if (!this.i18nRechtskreis) return ''
    return this.i18nRechtskreis['' + nr + '_' + this.lanId]
  },
  getI18NAenderungsgrund: function (nr) {
    if (!this.i18nAenderungsgrund) return ''
    return this.i18nAenderungsgrund['' + nr + '_' + this.lanId]
  },
  getI18NBranche: function (keyId) {
    if (!this.i18nBranches) return ''
    return this.i18nBranches['' + keyId + '_' + this.lanId]
  },
  updateBranches: function (data) {
    Vue.prototype.storage.configuration.i18nBranches = data
    Vue.prototype.storage.resetI18NState()
  },
  getI18NAbschlussart: function (abschlussArtNr) {
    if (!this.i18nAbschlussart) return ''
    return this.i18nAbschlussart['' + abschlussArtNr + '_' + this.lanId]
  },
  getI18NWaehrung: function (abschlussArtNr) {
    if (!this.i18nWaehrung) return ''
    return this.i18nWaehrung['' + abschlussArtNr + '_' + this.lanId]
  },
  getI18NQuelle: function (quelleNr) {
    return this.i18nQuelle['' + quelleNr + '_' + this.lanId]
  },
  getI18NCountry: function (key) {
    if (!this.countrySprache) return ''
    return this.countrySprache[key + '_' + this.lanId]
  },
  getI18NRegion: function (key) {
    if (!this.i18nRegion) return ''
    return this.i18nRegion[key + '_' + this.lanId]
  },
  viewport() {
    var e = window
    var a = 'inner'
    if (!('innerWidth' in window)) {
      a = 'client'
      e = document.documentElement || document.body
    }
    return {width: e[a + 'Width'], height: e[a + 'Height']}
  },
  convertValueToDecimal: function (b) {
    // console.log('->convertValueToDecimal', b)
    b = ('' + b).replace(/\,/g,'.')
    // console.log('<-convertValueToDecimal', b)
    return b
  },
  noExponent: function (value) {
    // console.log('noExponent', value)
    var data= String(value).split(/[eE]/);
    if(data.length === 1) return data[0];

    var  z= '', sign= this<0? '-':'',
      str= data[0].replace('.', ''),
      mag= Number(data[1])+ 1;

    if(mag<0){
      z= sign + '0.';
      while(mag++) z += '0';
      return z + str.replace(/^\-/,'');
    }
    mag -= str.length;
    while(mag--) z += '0';
    let res = str + z
    // console.log('noExponent', res)
    return res
  },
  createSearchDataFromFields: function (owner, headerFields) {
    var result = {
      hasAddItems: false
    }
    var searchData = {
      lastYear: true
    }
    let itemscurrencydimension = Vue.prototype.storage.getCurrencyDimensionList()
    Vue.prototype.storage.multipleYears = false

    let maskData = {}
    var filterString = ''
    for (var rowIndex in owner.maskConfig.rows) {
      var row = owner.maskConfig.rows[rowIndex]
      for (var aIndex in row.arr) {
        var data = row.arr[aIndex]
        var sub = ''
        let hasFactor = (data.type !== 'fromtodropdown')
        if (data.value) {
          let curDimension = null
          let factor = 1
          let curIndex = _.findIndex(itemscurrencydimension, function (o) {
            return o.id === data.dimension
          })
          if (curIndex > -1) {
            curDimension = itemscurrencydimension[curIndex]
          }
          if (curDimension !== null) {
            factor = curDimension.factor
          }
          if (data.field === 'balanceDate') {
            if (moment(data.value, 'DD.MM.YYYY',true).isValid()) {
              data.value = moment(data.value, 'DD.MM.YYYY',true).format('YYYY.MM.DD')
            }
          }
          if ((data.fieldType === 'sp') || (data.fieldType === 'kz') || (data.field === 'bankscore')) {
            let vArr = data.value.split(Vue.prototype.$api.splitChar)
            if (vArr[0]) {
              vArr[0] = vArr[0].replace(/\./g,'')
              vArr[0] = vArr[0].replace(/,/g,'.')
            }
            if (vArr[1]) {
              vArr[1] = vArr[1].replace(/\./g,'')
              vArr[1] = vArr[1].replace(/,/g,'.')
            }

            if ((vArr[0].length > 0) || (vArr[1].length > 0)) {
              if (!vArr[0] || !(vArr[0].length > 0)) {
                vArr[0] = '0'
              }
              if (!vArr[1] || !(vArr[1].length > 0)) {
                vArr[1] = '99999999999'
              }
            }
            if ((vArr[0].length > 0) && (vArr[1].length > 0)) {
              sub = sub + data.fieldType + ':' + data.field + ':' + this.noExponent(vArr[0] * factor)
              sub = sub + ':' + this.noExponent(vArr[1] * factor)

              if ((filterString.length > 0) && (sub.length > 0)) {
                filterString = filterString + ','
              }
              if (sub.length > 0) {
                filterString = filterString + sub
              }
            }
            continue
          }

          maskData[data.field] = data.value

          if (data.value && ('' + data.value).indexOf(',') > -1) {
            data.value = ('' + data.value).split(', ')
          }
          if (Array.isArray(data.value)) {
            if (data.field === 'year') {
              if (data.value.length > 1) {
                Vue.prototype.storage.multipleYears = true
              }
            }
            var v = data.value.join('|')
            if (v.length > 0) {
              result.hasAddItems = true
              if ((data.fieldType === 'sp') || (data.fieldType === 'kz')) {

                let vArr = v.split(Vue.prototype.$api.splitChar)
                if (vArr[0]) {
                  vArr[0] = vArr[0].replace(/\./g,'')
                  vArr[0] = vArr[0].replace(/,/g,'.')
                }
                if (vArr[1]) {
                  vArr[1] = vArr[1].replace(/\./g, '')
                  vArr[1] = vArr[1].replace(/,/g,'.')
                }
                sub = sub + data.fieldType + ':' + data.field + ':' + vArr[0]
                sub = sub + ':' + vArr[1]
              } else {
                if (v.indexOf(',') > -1) {
                  v = v.split(',')
                  v = v.join('|')
                }
                sub = sub + data.fieldType + ':' + data.field + ':' + v
              }
              if ((filterString.length > 0) && (sub.length > 0)) {
                filterString = filterString + ','
              }
              if (sub.length > 0) {
                filterString = filterString + sub
              }
            }
          } else {
            result.hasAddItems = true
            var v = data.value
            if (v.length > 0 || v === true) {
              if (data.type === 'checkbox') {
                v = '0'
                if (data.value) {
                  v = '1'
                }
              }

              if ((data.fieldType === 'sp') || (data.fieldType === 'kz') || (data.type === 'fromtodropdown')) {
                var vArr = v.split(Vue.prototype.$api.splitChar)
                if (vArr[0] === '') continue
                if (vArr[1] === '') continue

                if (vArr[0]) {
                  vArr[0] = vArr[0].replace(/,/g, '.')
                }
                if (vArr[1]) {
                  vArr[1] = vArr[1].replace(/,/g, '.')
                }

                if (hasFactor) {
                  sub = sub + data.fieldType + ':' + data.field + ':' + (vArr[0] * factor)
                  sub = sub + ':' + (vArr[1] * factor)
                } else {
                  sub = sub + data.fieldType + ':' + data.field + ':' + (vArr[0])
                  sub = sub + ':' + (vArr[1])
                }


              } else {
                var vArr = v.split(Vue.prototype.$api.splitChar)
                if (vArr[0] === '') continue
                if (vArr.length > 1) {
                  if (hasFactor) {
                    sub = sub + data.fieldType + ':' + data.field + ':' + (vArr[0] * factor)
                    sub = sub + ':' + (vArr[1] * factor)
                  } else {
                    sub = sub + data.fieldType + ':' + data.field + ':' + (vArr[0])
                    sub = sub + ':' + (vArr[1])
                  }
                } else {
                  sub = sub + data.fieldType + ':' + data.field + ':' + v
                }
                // filterString = filterString + ':' + v
              }
              if ((filterString.length > 0) && (sub.length > 0)) {
                filterString = filterString + ','
              }
              if (sub.length > 0) {
                filterString = filterString + sub
              }
            }
          }
        }
      }
    }
    Vue.prototype.storage.saveState(owner.maskDataName, maskData)

    searchData['filter'] = filterString
    searchData['module'] = owner.idModule
    searchData['columns'] = this.getColumnsString(headerFields)
    searchData.currency = Vue.prototype.storage.getCurrency()
    searchData.currencyDimension = Vue.prototype.storage.getCurrencyDimension()

    result['searchData'] = searchData
    Vue.prototype.$api.debug('result', result)

    return result
  },
  /**
   * https://peergrouptest.creditreform-rating.de/api/index-testConfig.php?
   * clientNr=138
   * clientDatabase=daimler2012&
   * publicDatabase=rating
   * language=1
   * module=companies
   * rk=1
   * guv=1
   * application=excel
   * type=JSON-SP
   *
   * @param onSuccess
   * @param onFailure
   */
  getStrukturBilanzConfiguration(rk, guvNr, configName, onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'getConfiguration',
      rk: rk,
      guv: guvNr,
      configName: configName,
      type: 'json',
      language: this.getLanguage()
    }
    params.userID = Vue.prototype.storage.getUserId()
    params = this.injectRequestData(params)
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    });
  },
  deleteConfiguration(configName, rk, guvNr, onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'deleteConfigurationList',
      rk: rk,
      guv: guvNr,
      configName: configName,
      userID: Vue.prototype.storage.getUserId(),
      type: 'json'
    }
    params = this.injectRequestData(params)
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    });
  },
  getConfigurationList(rk, guvNr, onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'getConfigurationList',
      rk: rk,
      guv: guvNr,
      type: 'json'
    }
    params.userID = Vue.prototype.storage.getUserId()
    params = this.injectRequestData(params)
    Vue.prototype.$api.debug('getConfigurationList', params)
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    });
  },
  /**
   *
   * @param response
   * @param formData
   * @param onSuccess
   */
  register(captchaCode, formData, onSuccess) {
    var url = Vue.prototype.storage.host() + '/ajaxRegister.php'
    var params = {
      captchaCode: captchaCode,
      data: formData
    }
    params.userID = -1
    try {
      params.userID = Vue.prototype.storage.getUserId()
    } catch (eee) {
      console.log('no user id')
    }
    try {

      params = this.injectRequestData(params)
      $.post(url, JSON.stringify(params), function (data) {
        onSuccess(data)
      }, 'json').fail(function (err) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', err)
      });
    } catch (eee) {
      Vue.prototype.$api.hideIdle()
      Vue.prototype.$eventHub.$emit('OnShowError', eee)
    }
  },
  sendSupportRequest(form, givenData, file, onSuccess, mailto) {
    var url = Vue.prototype.storage.host() + '/ajaxSupport.php'
    let xhr = new XMLHttpRequest()
    xhr.open('POST', url)
    xhr.responseType = 'blob'
    // Create an FormData object

    var data = new FormData();

    for (var prop in givenData) {
      data.append(prop, givenData[prop])
    }
    data.append('file', file)
    data.append('sender', Vue.prototype.$api.getCredentials().data.user.email)
    data.append('module', this.getModuleId())
    data.append('moduleName', this.getModuleId())
    if (mailto) {
      data.append('mailto', mailto)
    }

    // If you want to add an extra field for the FormData
    //data.append("CustomField", "This is some extra data, testing");

    $.ajax({
      type: "POST",
      enctype: 'multipart/form-data',
      url: url,
      data: data,
      processData: false,
      contentType: false,
      cache: false,
      timeout: 600000,
      success: function (data) {

        if (onSuccess) onSuccess(data)
      },
      error: function (e) {
        Vue.prototype.$api.hideIdle()
        $("#result").text(e.responseText);
        Vue.prototype.$api.debug("ERROR : ", e);
        $("#btnSubmit").prop("disabled", false);

      }
    });

    /*
    var params = {
      data: formData
    }
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(onFailure)*/
  },
  getSupportEmail (isBalance) {
    let mail = Vue.i18n.translate('EMAIL_SUPPORT')
    let key = ''
    if (this.getModuleId()) {
      if (isBalance) {
        key = 'EMAIL_SUPPORT_BALANCE_' + this.getModuleId().toUpperCase()
      } else {
        key = 'EMAIL_SUPPORT_' + this.getModuleId().toUpperCase()
      }
    }
    let newMail = Vue.i18n.translate(key)
    if (newMail && newMail.length > 0) {
      mail = newMail
    }
    return mail
  },
  /**
   *
   * @param rk
   * @param guvNr
   * @param configName
   * @param posSP
   * @param posKZ
   * @param onSuccess
   * @param onFailure
   */
  saveStrukturBilanzConfiguration(rk, guvNr, configName, posSP, posKZ, onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'setConfiguration',
      userID: Vue.prototype.storage.getUserId(),
      rk: rk,
      guv: guvNr,
      configName: configName,
      type: 'json',
      posSP: posSP,
      posKZ: posKZ,
      language: this.getLanguage()
    }
    params = this.injectRequestData(params)
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    });
  }
  ,
  getChangeLogs(onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'get',
      userID: Vue.prototype.storage.getUserId(),
      language: this.getLanguage()
    }
    params = this.injectRequestData(params)
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    });
  }
  ,
  getChangeLogBL(onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'getBankList',
      language: this.getLanguage()
    }
    params.userID = Vue.prototype.storage.getUserId()
    params = this.injectRequestData(params)
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    });
  }
  ,
  getAdminLogs(logFilter, onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'getDebugLog',
      Type: logFilter,
      language: this.getLanguage()
    }
    params.userID = Vue.prototype.storage.getUserId()
    params = this.injectRequestData(params)
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    });
  }
  ,
  updateChangeLogs(data, onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetChangeLog.php'
    var params = {
      method: 'update',
      userID: Vue.prototype.storage.getUserId(),
      data: data,
      language: this.getLanguage()
    }
    params = this.injectRequestData(params)
    $.post(url, JSON.stringify(params), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    });
  }
  ,
  resetCredentials: function (cmp) {
    if (window.localStorage) {
      window.localStorage.credentials = null
      this.credentials = null
    }
    Vue.prototype.$eventHub.$emit('OnLogin', false)
    cmp.$router.push('/Login')
  },

  hasCredentials: function () {
    if (this.getCredentials() && this.getCredentials().authorized) {
      return true
    } else {
      if (window.localStorage && window.localStorage.credentials) {
        this.credentials = JSON.parse(window.localStorage.credentials)
        if (this.getCredentials() && this.getCredentials().authorized) {
          return true
        }
      }
    }
    return false
  }
  ,
  checkConfigurationExists: function (onSuccess) {
    var cmponSuccess = onSuccess
    if (!Vue.prototype.storage.getConfiguration()) {
      this.getConfiguration('250', function (data) {
        if (cmponSuccess) cmponSuccess()
      })
    } else {
      if (cmponSuccess) cmponSuccess()
    }
  }
  ,
  checkCredentials: function (cmp, onSuccess) {
    var cmponSuccess = onSuccess
    if (Vue.prototype.$api.getCredentials() && Vue.prototype.$api.getCredentials().authorized) {
      this.checkConfigurationExists(function () {
        if (cmponSuccess) cmponSuccess()
        Vue.prototype.$eventHub.$emit('OnLogin', true)
      })
      return true
    } else {
      if (window.localStorage && window.localStorage.credentials) {
        this.credentials = JSON.parse(window.localStorage.credentials)
        if (this.credentials && this.credentials.authorized) {
          this.checkConfigurationExists(function () {
            if (cmponSuccess) cmponSuccess()
            Vue.prototype.$eventHub.$emit('OnLogin', true)
          })
          return true
        }
      }
    }
    cmp.$router.push('/Login')
  }
  ,
  getModuleList() {
    if (!this.getCredentials()) return []
    return this.getCredentials().moduleList
  },
  isModuleActive: function (item) {
    return ((item.publicDB !== '') || (item.privateDB !== ''))
  },
  /**
   *
   * @param idName like (balanceRating, kdf)
   * @returns {boolean}
   */
  hasProduct: function (idName) {
    var credits = this.getCredentials()
    var arr = []
    for (var index in credits.productList) {
      var product = credits.productList[index]
      if (product.id === idName) {
        // console.log('hasProduct', idName)
        return true
      }
    }
    //  console.log('hasNotProduct', idName)
    return false
  },
  getProducts: function () {
    var credits = this.getCredentials()
    var arr = {}
    for (var index in credits.productList) {
      var product = credits.productList[index]
      arr[product.id] = true
    }
    // console.log('getProducts', arr)
    return arr
  },
  getAllowedList() {
    var credits = Vue.prototype.$api.getCredentials()
    var arr = []
    for (var index in credits.moduleList) {
      var module = credits.moduleList[index]
      if (this.isModuleActive(module)) {
        arr.push(module.id)
      }
    }
    return arr.join(',')
  },
  getAllowedDataList(data) {
    var credits = Vue.prototype.$api.getCredentials()
    for (var index in credits.moduleList) {
      var module = credits.moduleList[index]
      if (this.isModuleActive(module)) {
        data['' + module.id] = JSON.stringify(module)
      }
    }
    return data
  },
  getFirstAllowedDataList() {
    var credits = Vue.prototype.$api.getCredentials()
    for (var index in credits.moduleList) {
      var module = credits.moduleList[index]
      if (this.isModuleActive(module)) {
        return module
      }
    }
    return null
  },
  /**
   * resetAnkerbank and resetPeergroup
   */
  resetAll() {
    var credits = Vue.prototype.$api.getCredentials()
    for (var index in credits.moduleList) {
      var module = credits.moduleList[index]
      Vue.prototype.storage.resetAnkerbank(module.id)
      Vue.prototype.storage.resetPeergroup(module.id)
    }
  },
  isAllowedToOpenModule(moduleId) {
    if (!this.getCredentials()) return false
    var credits = Vue.prototype.$api.getCredentials()
    if (credits) {
      if (credits.moduleList) {
        for (var index in credits.moduleList) {
          var module = credits.moduleList[index]
          if (module.id === moduleId) {
            if (this.isModuleActive(module)) {
              // console.log('module is Active', module, moduleId)
              return true
            }
          }
        }
      }
    }
    // console.log('module is not Active')
    return false
  },
  getLanguage: function () {
    if (Vue.prototype.$config.language.toLowerCase() === 'de') return 1
    if (Vue.prototype.$config.language.toLowerCase() === 'en') return 2
    return Vue.prototype.$config.language
  },
  searchOsmCities: function (queryString, reqState, onSuccess, onFailure) {
    this.sendGetRequest('https://nominatim.openstreetmap.org/search', {
      'accept-language': 'de',
      format: 'json',
      featureType: 'city',
      city: queryString
     }, reqState, function (data) {
      let result = [];
      for (let row of data) {
        let entry = {};
        if (row.addresstype === 'city' || row.addresstype === 'town') {
          entry.id = row.place_id;
          entry.title = row.display_name;
          entry.lat = row.lat;
          entry.lon = row.lon;
          result.push(entry);
        }
      }
      if (onSuccess) {
        onSuccess(result);
      }
     }    
     , onFailure);
  },
  getCityFromLatLon: function (lat, lon) {
    let result = undefined;

    try {
        let osmdata = null;
        $.ajax({
            url: 'https://nominatim.openstreetmap.org/reverse',
            type: 'GET',
            async: false,
            data: {
              'accept-language': 'de',
              format: 'json',
              addressdetails: 0,
              zoom: 10,
              lat: lat,
              lon: lon
            },
            success: function (response) { osmdata = response; }
        });
        if (osmdata && osmdata.name) {
          result = [];
          result['name'] = osmdata.name;
          result['title'] = osmdata.display_name;
        }
    } catch (error) {
        console.error(error);
    }
    return result;
  },
  getLatLngFromAddress: function (address, onSuccess) {
    var params = {
      query: address
    }
    /*
    $.post(Vue.config.host + '/ajaxOpensmap.php', JSON.stringify(params), function (data) {
      if (onSuccess) {
        onSuccess(data)
      }
    })
   */
    $.get(location.protocol + '//nominatim.openstreetmap.org/search?format=json&q=' + address, function (data) {
      Vue.prototype.$api.debug(data)
      onSuccess(data)
    })
  },
  injectRequestData(reqData) {
    reqData.language = this.getLanguage()
    window.edoLanguage = this.getLanguage()
    reqData.module = this.getModuleId()
    reqData.userID = Vue.prototype.storage.getUserId()
    // reqData.limit = 1000
    if (this.paramData) {
      if (this.paramData.clientNr) reqData.clientNr = this.paramData.clientNr
      if (this.paramData.clientDatabase) reqData.clientDatabase = this.paramData.clientDatabase
      if (this.paramData.clientDatabaseNr) reqData.clientDatabaseNr = this.paramData.clientDatabaseNr
      if (this.paramData.publicDatabase) reqData.publicDatabase = this.paramData.publicDatabase
      if (this.paramData.publicDatabaseNr) reqData.publicDatabaseNr = this.paramData.publicDatabaseNr
      if (this.paramData.hasOwnProperty('enableWithoutBalance')) reqData.enableWithoutBalance = this.paramData.enableWithoutBalance
    }

    Vue.prototype.$api.debug('injectRequestData', reqData)
    return reqData
  },
  injectRequestDataSmall(reqData) {
    reqData.language = this.getLanguage()
    // reqData.module = this.getModuleId()
    reqData.userID = Vue.prototype.storage.getUserId()
    if (this.paramData) {
      if (this.paramData.clientNr) reqData.clientNr = this.paramData.clientNr
      if (this.paramData.clientDatabase) reqData.clientDatabase = this.paramData.clientDatabase
      if (this.paramData.clientDatabaseNr) reqData.clientDatabaseNr = this.paramData.clientDatabaseNr
      if (this.paramData.publicDatabase) reqData.publicDatabase = this.paramData.publicDatabase
      if (this.paramData.publicDatabaseNr) reqData.publicDatabaseNr = this.paramData.publicDatabaseNr
      if (this.paramData.enableWithoutBalance) reqData.enableWithoutBalance = this.paramData.enableWithoutBalance
      reqData.peerDataLimit = 100
    }
    Vue.prototype.$api.debug('injectRequestData', reqData)
    return reqData
  },
  getParamData() {
    return this.paramData
  },
  setParamData(paramData) {
    Vue.prototype.$api.debug('setParamData', this.paramData)
    if (!paramData.hasOwnProperty('searchNoBalance')) {
      paramData.searchNoBalance = '1'
    }
    this.paramData = {
      clientNr: Vue.prototype.$api.getCredentials().data.user.userClientNr, // paramData.clientNr,
      clientDatabase: paramData.privateDB,
      clientDatabaseNr: paramData.privateDBNr,
      publicDatabase: paramData.publicDB,
      publicDatabaseNr: paramData.publicDBNr,
      enableWithoutBalance: paramData.searchNoBalance
    }
    Vue.prototype.$api.debug('setParamData done', this.paramData)
  },

  updateParamData(pd) {
    if (pd.enableWithoutBalance) {
      this.paramData.enableWithoutBalance = pd.enableWithoutBalance
    }

    Vue.prototype.$api.debug('updateParamData done', this.paramData)
  },
  resetParamData() {
    this.paramData = {
      clientNr: null,
      clientDatabase: null,
      clientDatabaseNr: null,
      publicDatabase: null,
      publicDatabaseNr: null,
      enableWithoutBalance: '1'
    }
    Vue.prototype.$api.debug('resetParamData', this.paramData)
  },
  saveSearchFieldConfigurations(data, callback) {
    if (!data) data = {}
    var url = Vue.prototype.storage.host() + '/ajaxSuchfeldKonfiguration.php'
    data['method'] = 'create'
    data = this.injectRequestData(data)
    $.post(url, JSON.stringify(data), function (data) {
      callback(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    })
  },
  getSearchFieldConfigurations(callback) {
    var url = Vue.prototype.storage.host() + '/ajaxSuchfeldKonfiguration.php'
    var data = {
      'method': 'post'
    }
    data = this.injectRequestData(data)
    $.post(url, JSON.stringify(data), function (data) {
      callback(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    })
  },
  deleteSearchFieldConfigurations (buyerNr, data, callback) {
    if (!buyerNr) {
      buyerNr = '250'
    }
    if (!data) data = {}
    var url = Vue.prototype.storage.host() + '/ajaxSuchfeldKonfiguration.php'
    data['buyerNr'] = buyerNr
    data['method'] = 'delete'
    data.userID = Vue.prototype.storage.userId
    $.post(url, JSON.stringify(data), function (data) {
      callback(data)
    }, 'json')
  },
  importSearchFieldConfigurations (hashValue, data, callback) {
    if (!data) data = {}
    var url = Vue.prototype.storage.host() + '/ajaxSuchfeldKonfiguration.php?method=import&hash=' + hashValue
    $.post(url, JSON.stringify(data), function (data) {
      callback(data)
    }, 'json')
  },
  reloadModule(fnSuccess) {
    if (this.lastModuleConfig !== null) {
      this.setModule(this.lastModuleConfig, fnSuccess)
    }
  },
  isModuleConfigSet(name) {
    if (!Vue.prototype.storage.configuration.moduleConfig) return false
    for (var index in Vue.prototype.storage.configuration.moduleConfig) {
      const item = Vue.prototype.storage.configuration.moduleConfig[index]
      if (item.Variable === name) {
        if (item.Wert === '1') {
          return true
        }
      }
    }
    return false
  },
  setModule(module, fnSuccess) {
    this.lastModuleConfig = JSON.parse(JSON.stringify(module))
    var credits = Vue.prototype.$api.getCredentials()
    if (credits) {
      if (credits.moduleList) {
        if (credits.moduleList[module.id]) {
          Vue.prototype.storage.hasAnkerBank = false
          this.setParamData(credits.moduleList[module.id])
        }
      }
    }
    Vue.prototype.$api.debug('module', module, credits)

    this.setModuleId(module.id)
    var postData = {}
    postData = this.injectRequestData(postData)
    var cmp = this
    $.post(Vue.config.host + '/AjaxSetDb.php', JSON.stringify(postData), function (data) {
      Vue.prototype.$api.debug('Module set', data)
      try {
        Vue.prototype.storage.rechtskreise = null
        Vue.prototype.storage.regionList = null
        Vue.prototype.storage.configuration.rechtsKreise = data.rechtskreise
        Vue.prototype.storage.configuration.regions = data.regionList
        Vue.prototype.storage.configuration.i18nQuelle = data.i18nQuelle
        Vue.prototype.storage.configuration.moduleConfig = data.moduleConfig
        Vue.prototype.storage.configuration.moduleNr = data.moduleNr
        cmp.updateBranches(data.branchCategories)
        Vue.prototype.$eventHub.$emit('I18NIsRefresh', true)
      } catch (e) {
        console.error(e)
      }
      if (fnSuccess) {
        fnSuccess(data)
      }

      Vue.prototype.$eventHub.$emit('setModuleDone', Vue.prototype.storage.configuration)
    }).fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    })
  },
  prepareWaimeaTable(data) {
    Vue.prototype.$api.debug('prepareWaimeaTable before', data)
    var result = {
      headers: [],
      rows: []
    }
    if (!data) return result
    for (var index in data.columns) {
      var item = data.columns[index]
      result.headers.push({
        text: item.title,
        format: item.format,
        meta: item,
        value: index,
        isExtraField: (item.extraField && item.extraField === true) ? true : false,
        columnClass: 'col' + result.headers.length + 1,
        index: result.headers.length + 1,
        id: result.headers.length + 1,
        isVisible: true,
        sortable: true
      })
    }
    for (var index in data.rows) {
      var cells = data.rows[index].cells
      if (!cells) {
        cells = {}
      }
      /*
      var extra = data.rows[index]
      cells.meta = _.clone(extra, false)
      // delete(cells.meta.cells)
      cells.meta.cells = null
      result.rows.push(extra)
       */
      var meta = _.clone(data.rows[index], false)
      meta.cells = null
      cells['meta'] = meta
      result.rows.push(cells)
    }
    /*
    for (var index in data.rows) {
      var cells = data.rows[index].cells
      var extra = data.rows[index]
      if (!cells) {
        cells = {}
      }
      cells.meta = _.clone(extra, true)
      delete(cells.meta.cells)
      result.rows.push(cells)
    }
     */
    Vue.prototype.$api.debug('prepareWaimeaTable after', result)
    return result
  }
  ,
  getBreadCrumpModule(id, sub, subsub) {
    var list = []
    if (id) {
      list.push({
        id: id + 'dashboard',
        icon: 'arrow_back',
        text: '',
        disabled: false,
        href: 'javascript:window.history.back()'
      })
    }
    list.push({
      id: id + 'dashboard',
      text: 'Dashboard',
      disabled: false,
      href: '/#/Dashboard'
    })
    if (id) {
      if (typeof id === "object") {
        list.push({
          id: id.id,
          text: id.text,
          disabled: false,
          href: id.href
        })
      } else {
        list.push({
          id: id + 'Module',
          text: Vue.i18n.translate(id.toUpperCase() + '_TITLE'),
          disabled: false,
          href: '/#/di/Module/' + id
        })
      }
      if (sub) {
        list.push({
          id: sub.id,
          text: sub.text,
          disabled: false,
          href: sub.href
        })
      }
      if (subsub) {
        list.push({
          id: subsub.id,
          text: subsub.text,
          disabled: false,
          href: subsub.href
        })
      }
    }
    Vue.prototype.$eventHub.$emit('OnGetBreadcrumb', list)
    return list
  }
  ,
  getModuleListItems(id) {
    var list = []
    var before = id
    list.push({
      id: 'search',
      name: 'Suche'
    }, {
      id: 'peergroup',
      name: 'Peergroup'
    }, {
      id: 'newsbox',
      name: 'Newsbox'
    })
    return list
  }
  ,
  onGetI18NFromHitList(data) {
    for (var rowIndex in data) {
      var rowItem = data[rowIndex]
      this.i18nTableHitList[rowItem.id + '_' + this.lanId] = {
        'lanKey': rowItem.id,
        'lanValue': rowItem.lanValue
      }
    }
  }
  ,
  onGetI18NFromMaskData(data) {
    for (var rowIndex in data) {
      var rowItem = data[rowIndex]
      this.i18nTable[rowItem.id + '_' + rowItem.lanId] = {
        'lanKey': rowItem.id,
        'lanValue': rowItem.lanValue
      }
    }
  }
  ,
  onGetI18NData(data) {
    // Vue.prototype.$api.debug('onGetI18NData', data)
    this.i18nTable = []
    for (var rowIndex in data) {
      var rowItem = data[rowIndex]
      this.i18nTable[rowItem.lanKey + '_' + this.lanId] = rowItem
    }
  }
  ,
  onGetI18NValue(langKey) {
    if (!this.i18nTable) return langKey
    var item = this.i18nTable[langKey + '_' + this.lanId]
    if (!item) return langKey
    return item.lanValue
  }
  ,
  onGetI18NHitListValue(langKey) {
    var item = this.i18nTableHitList[langKey + '_' + this.lanId]
    // Vue.prototype.$api.debug('key' + langKey + '_' + this.lanId + '=' + item.lanValue, langKey, this.i18nTableHitList)
    if (!item) return langKey
    return item.lanValue
  },
  getBalanceData(balanceArr, columns, onSuccess, onFailure) {
    let bArr = [];
    let doubleMap = {};
    for (var index in balanceArr) {
      let b = balanceArr[index];
      let bString = this.balanceToString(b);
      if (!doubleMap[bString]) {
        bArr.push(bString);
        doubleMap[bString] = true;
      }
    }
    return this.getBalanceDataWithBalanceStringArray(bArr, columns, onSuccess, onFailure);
  },

  getBalanceDataWithBalanceStringArrayOptimized(yearData, bArr, columns, onSuccess, onFailure) {
    var cmp = this

    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'

    var searchData = {}

    searchData['columns'] = this.getColumnsString(columns)
    searchData['balances'] = bArr
    searchData['optimizeToYear'] = yearData.year
    searchData['language'] = this.getLanguage()
    searchData.userId = Vue.prototype.storage.getUserId()
    searchData.type = 'JSON-BALANCES-RENEWED'
    searchData = this.injectRequestData(searchData)
    $.post(url, JSON.stringify(searchData), function (data) {
      onSuccess(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    })
  },

  getBalanceDataWithBalanceStringArray(bArr, columns, onSuccess, onFailure) {
    let searchData = {};
    searchData['columns'] = columns;
    searchData['balances'] = bArr;
    searchData.userId = Vue.prototype.storage.getUserId();
    searchData.type = 'JSON-BALANCES';
    searchData = this.injectRequestData(searchData);

    Vue.prototype.$api.sendPostRequest("ajaxGetBankData.php", searchData, null, onSuccess, onFailure);
  },

  /*
    TS 2025-02-01: Added for download center
  */
  getDownloads(data, onSuccess, onFailure) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/apiDownloadCenter.php'

    if (cmp.reqGetDownloads) {
      cmp.reqGetDownloads.abort();
    }

    cmp.reqGetDownloads = $.ajax(url, {
      type: 'GET',
      data: "list",
      success: function (data, statusText, jqXHR) {
        cmp.reqGetDownloads = null;
        Vue.prototype.$api.hideIdle()
        if (onSuccess) {
          onSuccess(data);
        }
      }
    })
    .fail(function(xhr, status, error) {
      Vue.prototype.$api.hideIdle()
      cmp.reqGetDownloads = null;
      if (onFailure) {
        onFailure(xhr, status, error);
      }
      else {
        Vue.prototype.$api.onAjaxFailure(xhr, status, error);
      }
    });
  },

  getHitlist (searchData, reqState, onSuccess, onFailure) {
    const cmp = this;
    const endpoint = 'ajaxGetHitlist.php';
    if (reqState && reqState.state) {
      reqState.state.abort();
    }

    searchData = this.injectRequestData(searchData);
    Vue.prototype.$api.sendPostRequest(endpoint, searchData, reqState, function(data) {
        if (onSuccess) {
          data.searchData = searchData;
          onSuccess(data);
        }
      },
      onFailure);
  },

  getBalancesHitlist (crefoNr, onSuccess, onFailure) {
    let searchData = {};
    searchData['action'] = 'page';
    searchData['mode'] = 'balances';
    searchData['sources'] = this.getSelectedSources();
    searchData['filter'] = [];
    searchData['filter'].push ({filterId: 2, value: crefoNr});
    searchData['columns'] = [ 1, 2, 16, 15, 14, 17];

    Vue.prototype.$api.getHitlist(searchData, null, onSuccess, onFailure);
  },

  getHitlistDownload (searchData, hitlistMode, onSuccess, onFailure) {
    let url = Vue.prototype.storage.host() + '/ajaxGetHitlist.php'

    if (this.reqDownloadHitlist) {
      this.reqDownloadHitlist.abort()
    }

    searchData = this.injectRequestData(searchData);
    searchData.action = 'createExcel';
    searchData.mode = hitlistMode;
    $.ajax(url, {
      type: 'POST',
      data: JSON.stringify(searchData),
      contentType : 'application/json',
      success: function (data, statusText, jqXHR) {
        if (onSuccess) {
          onSuccess(null);
        }
        if (data.resultType == 'excel') {
          // Create a new Blob object using the response data of the onload object
          var blob = new Blob([Buffer.from(data.excelBase64, 'base64')], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
          // Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
          let a = document.createElement("a");
          // does not work in IE a.style = "display: none";
          document.body.appendChild(a);
          // Create a DOMString representing the blob and point the link element towards it
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = 'Trefferliste.xlsx';
          // programatically click the link to trigger the download
          a.click();
          // release the reference to the file by revoking the Object URL
          window.URL.revokeObjectURL(url);
        }
      }
    })
    .fail(function(xhr, status, error) {
      if (onFailure) {
        onFailure(xhr, status, error);
      }
      else {
        Vue.prototype.$api.onAjaxFailure(xhr, status, error);
      }
    });
  },

  searchBanks(searchData, onSuccess, onFailure) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetHitlist.php'

    if (cmp.reqSearchBanks) {
      cmp.reqSearchBanks.abort()
    }
    searchData = this.injectRequestData(searchData);
    searchData.action = 'createExcel';
    Vue.prototype.$api.debug('export searchBanks to Excel', searchData);

    $.ajax(url, {
        type: 'POST',
        data: JSON.stringify(searchData),
        contentType : 'application/json',
        success: function (data, statusText, jqXHR) {
            onSuccess(null);
            if (data.resultType == 'excel') {
                // Create a new Blob object using the response data of the onload object
                var blob = new Blob([Buffer.from(data.excelBase64, 'base64')], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                // Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
                let a = document.createElement("a");
                // does not work in IE a.style = "display: none";
                document.body.appendChild(a);
                // Create a DOMString representing the blob and point the link element towards it
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = 'Trefferliste.xlsx';
                // programatically click the link to trigger the download
                a.click();
                // release the reference to the file by revoking the Object URL
                window.URL.revokeObjectURL(url);
            }
        }
    })
    .fail(function(xhr, status, error) {
        onFailure(null);
    });
  },

  searchBanksPeergroup(searchData, onSuccess, onFailure) {
    var url = Vue.prototype.storage.host() + '/ajaxGetHitlist.php'
    searchData.userId = Vue.prototype.storage.getUserId()
    // searchData.limit = Vue.prototype.storage.getLimitByName('MaxHitsPeergroupSearch')
    searchData.mode = 'balances';
    searchData = this.injectRequestData(searchData)
    var cmp = this
    if (cmp.reqSearchBanksPeergroup) {
      cmp.reqSearchBanksPeergroup.abort()
    }

    searchData.action = 'createExcel';
    Vue.prototype.$api.debug('export searchBanks to Excel', searchData);
    $.ajax(url, {
        type: 'POST',
        data: JSON.stringify(searchData),
        contentType : 'application/json',
        success: function (data, statusText, jqXHR) {
            onSuccess(null);
            if (data.resultType == 'excel') {
                // Create a new Blob object using the response data of the onload object
                var blob = new Blob([Buffer.from(data.excelBase64, 'base64')], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                // Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
                let a = document.createElement("a");
                // does not work in IE a.style = "display: none";
                document.body.appendChild(a);
                // Create a DOMString representing the blob and point the link element towards it
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = 'Trefferliste.xlsx';
                // programatically click the link to trigger the download
                a.click();
                // release the reference to the file by revoking the Object URL
                window.URL.revokeObjectURL(url);
            }
        }
    })
    .fail(function(xhr, status, error) {
        onFailure(null);
    });
  },

  getStackTrace() {
    try {
      var err = new Error();
      return err.stack;

    } catch (e) {

    }
    return ''
  },
  exportSearchFieldConfigurations (list) {
    var url = Vue.prototype.storage.host() + '/ajaxSuchfeldKonfiguration.php'
    window.location.href = url + '?method=download&idList=' + JSON.stringify(list) + '&time=' + new Date().getTime()
  },

  getI18NFromServer(callback) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetConfiguration.php'
    var data = {}
    data.userID = Vue.prototype.storage.getUserId()
    if (cmp.reqConfiguration) {
      // cmp.reqConfiguration.abort()
    }
    data = this.injectRequestData(data)
    Vue.prototype.storage.resetI18NState()
    cmp.reqConfiguration = $.post(url, JSON.stringify(data), function (data) {
      cmp.updateLocaleData(data.i18n)
      if (callback) callback()
    })
  },
  updateLocaleData(data) {
    var lan = '' + Vue.prototype.$api.getLanguage()
    if (lan === '1') {
      Vue.i18n.replace('de', data)
    }
    if (lan === '2') {
      Vue.i18n.replace('en', data)
    }
    // console.log('updateLocaleData', data)
  },
  getConfiguration(buyerNr, callback) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxGetConfiguration.php'
    var data = {
      'buyerNr': buyerNr
    }
    this.lanId = window.edoLanguage
    data.userID = Vue.prototype.storage.getUserId()
    if (cmp.reqConfiguration) {
      // cmp.reqConfiguration.abort()
    }
    data = this.injectRequestData(data)
    cmp.reqConfiguration = $.post(url, JSON.stringify(data), function (data) {
      // cmp.reqConfiguration = null
      cmp.i18nRechtskreis = []
      cmp.i18nAenderungsgrund = []
      cmp.countrySprache = []
      cmp.i18nAbschlussart = []
      cmp.i18nBranches = []
      cmp.i18nWaehrung = []
      cmp.i18nCurrency = []
      cmp.i18nCurrencyDimension = []
      cmp.i18nQuelle = []
      cmp.i18nRegion = []
      cmp.i18nTableHitList = []
      Vue.prototype.storage.currencyDimensionList = []
      Vue.prototype.storage.currencyList = []
      // window.edoUserId = data.systemConfig.clientNr
      // Vue.prototype.storage.getUserId() = window.edoUserId


      Vue.prototype.storage.configuration = data
      cmp.onGetI18NData(Vue.prototype.storage.configuration.i18n)
      cmp.onGetI18NFromMaskData(Vue.prototype.storage.configuration.i18nSearchMask)
      cmp.onGetI18NFromHitList(Vue.prototype.storage.configuration.i18nHitList)


      var rowItem = null
      var rowIndex = 0
      for (rowIndex in Vue.prototype.storage.configuration.i18nHitList) {
        rowItem = Vue.prototype.storage.configuration.i18nHitList[rowIndex]
        cmp.i18nTableHitList[rowItem.id + '_' + rowItem.lanId] = {
          'lanKey': rowItem.id,
          'lanValue': rowItem.lanValue
        }
      }
      for (rowIndex in Vue.prototype.storage.configuration.i18nRechtskreis) {
        rowItem = Vue.prototype.storage.configuration.i18nRechtskreis[rowIndex]
        cmp.i18nRechtskreis[rowItem.id + '_' + rowItem.lanId] = rowItem
      }
      for (rowIndex in Vue.prototype.storage.configuration.i18nAenderungsgrund) {
        rowItem = Vue.prototype.storage.configuration.i18nAenderungsgrund[rowIndex]
        cmp.i18nAenderungsgrund[rowItem.id + '_' + rowItem.lanId] = rowItem
      }
      for (rowIndex in Vue.prototype.storage.configuration.i18nWaehrung) {
        rowItem = Vue.prototype.storage.configuration.i18nWaehrung[rowIndex]
        cmp.i18nWaehrung[rowItem.id + '_' + rowItem.lanId] = rowItem
      }
      for (rowIndex in Vue.prototype.storage.configuration.i18nQuelle) {
        rowItem = Vue.prototype.storage.configuration.i18nQuelle[rowIndex]
        cmp.i18nQuelle[rowItem.lanKey + '_' + rowItem.lanId] = rowItem
      }
      for (rowIndex in Vue.prototype.storage.configuration.regions) {
        rowItem = Vue.prototype.storage.configuration.regions[rowIndex]
        cmp.i18nRegion[rowItem.id + '_' + rowItem.lanId] = rowItem
      }

      for (rowIndex in Vue.prototype.storage.configuration.countries) {
        rowItem = Vue.prototype.storage.configuration.countries[rowIndex]
        cmp.countrySprache[rowItem.id + '_' + rowItem.lanId] = rowItem
      }
      for (rowIndex in Vue.prototype.storage.configuration.i18nAbschlussart) {
        rowItem = Vue.prototype.storage.configuration.i18nAbschlussart[rowIndex]
        cmp.i18nAbschlussart[rowItem.id + '_' + rowItem.lanId] = rowItem
      }
      for (rowIndex in Vue.prototype.storage.configuration.i18nBranches) {
        rowItem = Vue.prototype.storage.configuration.i18nBranches[rowIndex]
        cmp.i18nBranches[rowItem.id + '_' + rowItem.lanId] = rowItem
      }
      for (rowIndex in Vue.prototype.storage.configuration.waehrung) {
        rowItem = Vue.prototype.storage.configuration.waehrung[rowIndex]
        cmp.i18nCurrency['' + rowItem.id] = rowItem

        Vue.prototype.storage.currencyList.push({
          id: rowItem.id,
          lanId: 1,
          display: rowItem.display,
          orderNr: rowItem.orderNr,
          title: rowItem.name
        })
      }
      for (rowIndex in Vue.prototype.storage.configuration.waehrungsdimension) {
        rowItem = Vue.prototype.storage.configuration.waehrungsdimension[rowIndex]
        cmp.i18nCurrencyDimension[rowItem.id +  '_' + rowItem.lanId] = rowItem
        Vue.prototype.storage.currencyDimensionList.push(rowItem)
      }

      var myLocaleDE = []
      var myLocaleEN = []
      for (rowIndex in Vue.prototype.storage.configuration.i18n) {
        rowItem = Vue.prototype.storage.configuration.i18n[rowIndex]
        if (rowItem.lanId === '1') {
          myLocaleDE[rowItem.lanKey] = rowItem.lanValue
        }
        if (rowItem.lanId === '2') {
          myLocaleEN[rowItem.lanKey] = rowItem.lanValue
        }
      }

      // Vue.i18n.add('de', data.i18n)
      // Vue.i18n.add('en', myLocaleEN)
      cmp.updateLocaleData(data.i18n)

      // Vue.prototype.$api.debug('setlocale', Vue.prototype.$config.languageId)
      Vue.prototype.$eventHub.$emit('setLocale', Vue.prototype.$config.languageId)
      Vue.prototype.$eventHub.$emit('setLocale2', Vue.prototype.$config.languageId)

      callback(data)
    }, 'json').fail(function (err) {
      Vue.prototype.$eventHub.$emit('OnShowError', err)
    })
  },

  onAjaxFailure (xhr, status, error) {
    Vue.prototype.$eventHub.$emit('OnShowError', {xhr: xhr, status: status, error: error});
  },

  getExportInfo (exportType, searchData, onSuccess, onFailure) {
    var data = searchData;
    var url = Vue.prototype.storage.host() + '/ajaxGetHitlist.php';

    data.mode = exportType;
    data.action = 'count';
    $.ajax(url, {
      type: 'POST',
      data: JSON.stringify(data),
      contentType : 'application/json',
      success: function (data, statusText, jqXHR) {
        if (onSuccess) {
          onSuccess(data);
        }
      }
    })
    .fail(function(xhr, status, error) {
      if (onFailure) {
        onFailure(xhr, status, error);
      }
    });
  },

  getUserSettings(data, onSuccess, onFailure) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxUserSettings.php'

    if (cmp.reqUserSettinngs) {
      cmp.reqUserSettinngs.abort();
    }

    cmp.reqUserSettinngs = $.ajax(url, {
      type: 'GET',
      data: "get=ALL",
      success: function (data, statusText, jqXHR) {
        cmp.reqUserSettinngs = null;
        Vue.prototype.$api.hideIdle()
        if (onSuccess) {
          onSuccess(data);
        }
      }
    })
    .fail(function(xhr, status, error) {
      Vue.prototype.$api.hideIdle()
      cmp.reqUserSettinngs = null;
      if (onFailure) {
        onFailure(xhr, status, error);
      }
      else {
        Vue.prototype.$api.onAjaxFailure(xhr, status, error);
      }
    });
  },

  sendPostRequest(endPoint, data, reqState, onSuccess, onFailure) {
    Vue.prototype.$api.sendAjaxRequest('POST', endPoint, JSON.stringify(data), 'application/json', reqState, onSuccess, onFailure);
  },

  sendGetRequest(endPoint, data, reqState, onSuccess, onFailure) {
    this.sendAjaxRequest('GET', endPoint, data, '', reqState, onSuccess, onFailure);
    //application/x-www-form-urlencoded; charset=UTF-8
  },

  sendAjaxRequest(verb, endPoint, data, contentType, reqState, onSuccess, onFailure) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/' + endPoint;
    if (endPoint.startsWith('https://')) {
      url = endPoint;
    }

    if (reqState && reqState.state) {
      reqState.state.abort();
    }

    var req = $.ajax(url, {
      type: verb,
      data: data,
      contentType : contentType,
      success: function (data, statusText, jqXHR) {
        if (reqState) {
          reqState.state = null;
        }
        if (onSuccess) {
          onSuccess(data);
        }
      }
    })
    .fail(function(xhr, status, error) {
      Vue.prototype.$api.hideIdle()
      if (reqState) reqState.state = null;
      if (status === 'abort') return;
      if (onFailure) {
        onFailure(xhr, status, error);
      }
      else {
        Vue.prototype.$api.onAjaxFailure(xhr, status, error);
      }
    });
    if (reqState) reqState.state = req;
  },

  setUserSettings(data, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxUserSettings.php', data, onSuccess, onFailure)
  },

  getSearchMaskItems (grouping, itemType, query, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getSearchMaskItems', itemType: itemType, query: query, module: this.currentModuleId, grouping: grouping }, null, onSuccess);
  },

  getHitlistConfigurations (mode, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getHitlistStorageNames', module: this.currentModuleId, mode: mode }, null, onSuccess, onFailure);
  },
  getHitlistConfiguration (mode, storageName, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getHitlistConfig', module: this.currentModuleId, mode: mode, storageName: storageName }, null, onSuccess);
  },
  setHitlistConfiguration (mode, storageName, hitlistConfig, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'setHitlistConfig', module: this.currentModuleId, mode: mode, storageName: storageName, hitlistConfig: hitlistConfig }, null, onSuccess, onFailure);
  },
  getSelectItemsForSearchItem (searchArea, listOfIds, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getSelectItems', w: searchArea, ids: listOfIds }, null, onSuccess, onFailure);
  },
  getFilterInfo (filterId, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getFilterInfo', module: this.currentModuleId, filterId: filterId }, null, onSuccess, onFailure);
  },
  getFilterUiList (filterId, subGroup, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getFilterUiList', module: this.currentModuleId, filterId: filterId, subGroup: subGroup }, null, onSuccess, onFailure);
  },
  getFilterRuleText (searchFilter, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getFilterRuleText', module: this.currentModuleId, filter: searchFilter }, null, onSuccess, onFailure);
  },
  getDataSources (onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getDataSources', module: this.currentModuleId }, null, onSuccess, onFailure);
  },
  getSelectedSources () {
    return Vue.prototype.storage.getState(this.currentModuleId + '_selectedSources');
  },
  setSelectedSources (sources, onSuccess, onFailure) {
    Vue.prototype.storage.saveState(this.currentModuleId + '_selectedSources', sources);
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'setSelectedDataSources', module: this.currentModuleId, sources: sources }, null, onSuccess, onFailure);
  },
  getFilterRulesets (mode, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'getRulesets', module: this.currentModuleId, mode: mode }, null, onSuccess, onFailure);
  },
  saveFilterRuleset (mode, rulesetName, data, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'saveRuleset', module: this.currentModuleId, mode: mode, rulesetName: rulesetName, data: data }, null, onSuccess, onFailure);
  },
  loadFilterRuleset (mode, rulesetName, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'loadRuleset', module: this.currentModuleId, mode: mode, rulesetName: rulesetName }, null, onSuccess, onFailure);
  },
  deleteFilterRuleset (mode, rulesetName, onSuccess, onFailure) {
    return this.sendPostRequest('ajaxSearchItemManager.php', { action: 'deleteRuleset', module: this.currentModuleId, mode: mode, rulesetName: rulesetName }, null, onSuccess, onFailure);
  },

  parseLocaleNumber (numberString) {
    const group = '.';
    const decimal = ',';

    if (typeof numberString !== 'string') {
      return numberString;
    }
    let result = numberString.replace(group, '');
    result = result.replace(decimal, '.');
    result = result.replace(/\s.*$/, '');

    return +result;
  },

  formatLocaleNumber (format, number) {
    const f = format.split('');
    let result = '';

    number = Number.parseFloat(number);
    switch (f[0]) {
      case 'w':
        const dimension = Vue.prototype.$api.getI18NCurrencyDimension(f[1]);
        number = number / dimension.factor;
        result = number.toLocaleString("de-DE", {minimumFractionDigits: 2, maximumFractionDigits: 2});
        if (dimension.factor != 1) {
          result = result + " " + dimension.name;
        }
        result = result + " €";
        break;
      case 'n':
        result = number.toLocaleString("de-DE", {minimumFractionDigits: f[1], maximumFractionDigits: f[1]})
        break;
      case 'p':
          result = number.toLocaleString("de-DE", {minimumFractionDigits: f[1], maximumFractionDigits: f[1]})
          result = result + " %";
          break;
      case 'f':
        result = number.toLocaleString("de-DE", {minimumFractionDigits: 0, maximumFractionDigits: f[1]})
        break;
      default:
        result = ""+number;
    }

    return result;
  },

  formatString (format, data) {
    return format.replace(/{([^{}]*)}/g, function (match, v) {
      let replacement = data[v];
      return typeof replacement === 'string' || typeof replacement === 'number' ? replacement : match;
    });
  },
  
  createSearchFilterId (filterId, subFilterId) {
    let result = filterId;
    if (result && subFilterId) {
      result += '_' + subFilterId;
    }
    return result;
  },

  pathOfNode (path, root, id) {

    for (let node of root) {
      if (node.id == id) {
        return true;
      }
    }

    for (let node of root) {
      if (node.children && node.children.length > 0) {
        path.push(node);
        if (this.pathOfNode(path, node.children, id) === true)
          return true;
        path.pop();
      }
    }

    return false;
  },

  findNode (root, id) {
    for (const node of root) {
      if (node.id === id) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        let found = this.findNode(node.children, id);
        if (found !== undefined) return found;
      }
    }
    return undefined;
  },

  setUserSettingsX(data, onSuccess, onFailure) {
    var cmp = this
    var url = Vue.prototype.storage.host() + '/ajaxUserSettings.php'

    $.ajax(url, {
      type: 'POST',
      data: JSON.stringify(data),
      contentType : 'application/json',
      success: function (data, statusText, jqXHR) {
        cmp.reqUserSettinngs = null;
        if (onSuccess) {
          onSuccess(data);
        }
      }
    })
    .fail(function(xhr, status, error) {
      Vue.prototype.$api.hideIdle()
      if (onFailure) {
        onFailure(xhr, status, error);
      }
      else {
        Vue.prototype.$api.onAjaxFailure(xhr, status, error);
      }
    });
  }
}
export default BaseApi


// WEBPACK FOOTER //
// ./src/api.js